import { nanoid } from "nanoid";
import { ManagementArea } from "../area-models/management-area.model";
import { SpeciesData } from "../catch-table-models/species-data.model";
import { Coordinate } from "../coordinate.model";

export class LostRecoveredGearForm {

    internalId: string = '';

    isSubmitted: boolean = false;

    /* Dates and gear status */

    reportDate: Date = new Date();

    declarationDate: Date = new Date(); 
  
    gearStatus: string = '';
  
    gearLostDate: Date = new Date();
  
    gearRecoveredDate: Date = new Date();

    /* Gear details */

    gearID: string = '';

    gearDescription: string = '';

    numberOfGears!: number;

    netLength!: number;

    numberOfBuoys!: number;

    buoyDescription: string = '';

    tagList: string[] = [];

    ropeLength!: number;

    licenseNumber: string = '';

    targetSpecies: SpeciesData = new SpeciesData();

    /* Location details */

    managementArea: ManagementArea = new ManagementArea();

    latitude!: Coordinate;

    longitude!: Coordinate;

    vesselDirection: string = '';

    comments: string = ''; // optional
  

  
    constructor() {
        this.internalId = 'id-' + nanoid();
    }


    toString() {

    }


    public static transformAnonymous(gearReports: any): LostRecoveredGearForm[] {
        
        if (!gearReports) {
            return [];
        }

        let transformedReports: LostRecoveredGearForm[] = [];

        for (let gearReport of gearReports) {
            let gr = new LostRecoveredGearForm();
            gr.internalId = gearReport.internalId;
            gr.isSubmitted = gearReport.isSubmitted ?? false;
            gr.reportDate = new Date(gearReport.reportDate);
            gr.declarationDate = new Date(gearReport.declarationDate); 
            gr.gearStatus = gearReport.gearStatus;
            gr.gearLostDate = new Date(gearReport.gearLostDate);
            gr.gearRecoveredDate = new Date(gearReport.gearRecoveredDate);
            gr.gearID = gearReport.gearID;
            gr.gearDescription = gearReport.gearDescription;
            gr.numberOfGears = gearReport.numberOfGears;
            gr.netLength = gearReport.netLength;
            gr.numberOfBuoys = gearReport.numberOfBuoys;
            gr.buoyDescription = gearReport.buoyDescription;
            gr.tagList = gearReport.tagList;
            gr.ropeLength = gearReport.ropeLength;
            gr.licenseNumber = gearReport.licenseNumber;
            gr.targetSpecies = SpeciesData.transformAnonymous(gearReport.targetSpecies);
            gr.managementArea = ManagementArea.transformAnonymous(gearReport.managementArea);
            gr.latitude = Coordinate.transformAnon(gearReport.latitude);
            gr.longitude = Coordinate.transformAnon(gearReport.longitude);
            gr.vesselDirection = gearReport.vesselDirection;
            gr.comments = gearReport.comments;
            transformedReports.push(gr);
        }
        return transformedReports;
    }

}
